"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StepLabelComponent = _interopRequireDefault(require("../../components/StepLabelComponent"));
const styleOverrides = {
  root: {
    flexDirection: 'column'
  },
  iconContainer: {
    margin: 0,
    paddingRight: 0
  },
  labelContainer: {
    '& > .MuiStepLabel-label': {
      marginTop: 10,
      textAlign: 'center'
    },
    '& > .MuiStepLabel-label:empty': {
      marginTop: 0
    }
  },
  label: {
    fontWeight: 'normal'
  }
};
const defaultProps = {
  StepIconComponent: _StepLabelComponent.default
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
